 
import styles from "./app-headersmall.module.css";
import {   useLocation } from "react-router-dom";
import MenuLeft from "../menuleft/menuleft";
 
import { useEffect, useState } from "react";
 
import ButtonOrdBox from "../buttonordbox/buttonordbox";

export function AppHeaderSmall() {
  const location = useLocation().pathname;
  const [isbox, setbox] = useState(true);

  useEffect(() => {
    if (location === "/" || location.indexOf("order") !== -1) {
      setbox(false);
    } else {
      setbox(true);
    }
  }, [location]);

  return (
    <div className={styles.main}>
      <div className={styles.menu}>
        <MenuLeft></MenuLeft>
      </div>

      {isbox && (
        <div className={styles.link}>
          <ButtonOrdBox></ButtonOrdBox>
        </div>
      )}
    </div>
  );
}
export default AppHeaderSmall;
